






















import { Component, Vue, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax';
import AbpBase from '../../lib/abpbase';
@Component
/*
 * 示例：<BusinessField ref="businessArea" :value="values"></BusinessField>
 * 通过value设置已选值，格式 [{directoryValue: 1000, children: [1001, 1002]}]
 * 通过$refs调用GetData()获取值，示例：(this as any).$refs.businessArea.GetData();
 * 通过GetData()得到的值格式为[[businessArea1], [businessArea2]]，对应businessArea1 = [0]、businessArea2 = [1]
 */
export default class BusinessField extends AbpBase {
	@Prop({type: Array}) value:Array<any>;
	@Prop({}) disabled:boolean;
	initData:any = {
		index: null,
		loading: false,
		valuesA: [],
		valuesB: [],
		firstValue1: [],
		secondValue: [],
		bussinessAreas: [],
		bussinessAreaSubs: [],
		results: [],
		datas: {}
	}
	// 初始化选项
	initSelect() {
		this.initData.index = null;
		this.initData.valuesA = [];
		this.initData.valuesB = [];
		this.initData.bussinessAreaSubs = [];
		this.value.forEach((item:any) => {
			this.initData.valuesA.push(item.directoryValue);
			this.initData.valuesB.push(item.children || []);
			this.initData.bussinessAreaSubs.push([]);
			this.handleLoadData(item.directoryValue);
		})
	}
	// 获取业务领域
    async handleGetBussinessArea() {
    	this.initData.loading = true;
    	await Ajax.get('/api/services/app/SysBaseData/GetBussinessAreaAsync').then((res:any)=>{
            this.initData.bussinessAreas = res.data.result.items.map((item:any) => {
            	return {
            		id: item.id,
            		label: item.directoryName,
            		value: item.directoryValue
            	}
            })
            this.initData.loading = false;
        })
    	if(this.value) this.initSelect();
    }
    // 获取业务领域下一级
    async handleLoadData(code:any) {

    	// 获取下标，用于赋值
    	let indexs:any = [];
    	if(this.initData.index !== null) {
    		indexs.push(this.initData.index);
    		this.initData.valuesB[this.initData.index] = [];
    	}else{
    		this.initData.valuesA.forEach((res:any, index:any) => {
	    		if(res == code) {
	    			indexs.push(index);
	    		}
	    	})
    	}
    	
    	// 通过code获取一级的数据
    	let item:any = this.initData.bussinessAreas.filter((res:any) => {
    		return res.value == code;
    	})
    	item = item[0];
    	
    	// 如果没有下级，不显示第二级，需要清空第二级对应的选择的数据
    	if(item.childs == false) {
    		this.handleAsyncData(indexs, []);
    		return;
    	}
    	
    	// 如果二级数据已经缓存，直接返回
    	if(this.initData.datas[code]) {
			this.handleAsyncData(indexs, this.initData.datas[code]);
			return;
		}
    	
    	this.initData.loading = true;
    	await Ajax.get('/api/services/app/SysBaseData/GetBussinessAreaByParentIdAsync', {params: {Id: item.id}}).then((res:any)=>{
    		// 如果当前一级请求发现没有第二级数据，设置childs为false，用于阻止第二次加载
    		if(res.data.result.items.length == 0) {
    			this.initData.bussinessAreas = this.initData.bussinessAreas.map((arr:any) => {
		    		if(arr.value == code) {
		    			arr.childs = false;
		    		}
		    		return arr;
		    	})
    			this.handleAsyncData(indexs, []);
    			this.initData.loading = false;
    			return;
    		}
    		// 如果有数据，缓存当前的二级数据
    		this.initData.datas[code] = res.data.result.items.map((obj:any) => {
            	return {
            		id: obj.id,
            		label: obj.directoryName,
            		value: obj.directoryValue
            	}
           	});
    		this.handleAsyncData(indexs, this.initData.datas[code]);
            this.initData.loading = false;
    	}).catch(() => {
        	this.initData.loading = false;
       	})
    }
    // 同步第二级数据
    handleAsyncData(indexs:any, datas:any) {
    	indexs.forEach((item:any) => {
    		Vue.set(this.initData.bussinessAreaSubs, item, datas);
    	})
    }
    // 获取选择的数据，可外部访问调用
    GetData() {
    	let arr:any = [];
    	this.initData.valuesB.forEach((res:any) => {
    		if(res.length > 0) {
    			res.forEach((item:any) => {
    				if(arr.indexOf(item) == -1) {
    					arr.push(item);
    				}
    			})
    		}
    	})
    	return [this.initData.valuesA, arr];
    }
    // 监听value变化，用于设置默认值
    @Watch('value')
  	defualtValueChange(val:any, oldVal:any) {
  		if(val) {
  			this.initSelect();
  		}
  	}
  	// 添加一个商业领域选择
  	handleAdd() {
  		this.initData.valuesA.push('');
  		this.initData.valuesB.push([]);
  		this.initData.bussinessAreaSubs.push([]);
  	}
  	// 删除一个商业领域选择
  	handleDelete(index:any) {
  		this.initData.valuesA.splice(index, 1);
  		this.initData.valuesB.splice(index, 1);
  		this.initData.bussinessAreaSubs.splice(index, 1);
  	}
  	handleOpenChange(index:any) {
  		this.initData.index = index;
  	}
    mounted() {
    	this.handleGetBussinessArea();
    }
}
